'use client';

import { VerifyActionProvider } from '@/providers/VerifyActionProvider';
import { VerifyProfileProvider } from '@/providers/VerifyProfileProvider';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import type { PropsWithChildren } from 'react';
import { Aside } from '../Aside';
import { ChatRuleModal } from '../Aside/ChatRuleModal';
import { ConfirmPasswordModal } from '../Auth/ConfirmPasswordModal';
import { ForgotPassword } from '../Auth/ForgotPassword';
import { Login } from '../Auth/Login';
import { Register } from '../Auth/Register';
import { VerifyPasswordModal } from '../Auth/VerifyPasswordModal';
import { BunkerModal } from '../Bunker';
import { BunkerSuccessModal } from '../Bunker/BunkerSuccessModal';
import { Footer } from '../Footer';
import { ChatPopup } from '../Header/ChatPopup';
import { HeaderTop } from '../Header/HeaderTop';
import { InfoModal } from '../Info';
import { KycModal } from '../Kyc';
import { Navbar } from '../Navbar';
import { NavbarMobile } from '../Navbar/NavbarMobile';
import { Profile } from '../Profile';
import { InfoPhoneVerifyModal } from '../Profile/Account/Info/InfoPhoneVerifyModal';
import { VerifyProfileModal } from '../Profile/Account/Verify';
import { TransactionDetailModal } from '../Profile/Transaction/Detail';
import { SearchModal } from '../Search';
import { WalletModal } from '../Wallet';
import { CouponsModal } from '../Wallet/Coupons/CouponsModal';
export const HomeLayout: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [opened, {
    toggle
  }] = useDisclosure();
  return <AppShell header={{
    height: 120
  }} navbar={{
    width: {
      base: 92,
      lg: 287
    },
    breakpoint: 'sm',
    collapsed: {
      mobile: !opened
    }
  }} aside={{
    width: 287,
    breakpoint: 'xl',
    collapsed: {
      desktop: false,
      mobile: true
    }
  }} padding={{
    base: 'md',
    xl: 0
  }}>
      <HeaderTop opened={opened} toggle={toggle} />
      <Navbar />
      <Aside />
      <AppShell.Main>
        <NavbarMobile />
        {children}
        <Footer />
        <>
          <ChatPopup />
          <Register />
          <Login />
          <InfoModal />
          <ForgotPassword />
          <VerifyPasswordModal />
          <ConfirmPasswordModal />
          <SearchModal />
          <TransactionDetailModal />
          <WalletModal />
          <CouponsModal />

          <VerifyActionProvider>
            <KycModal />
          </VerifyActionProvider>

          <VerifyProfileProvider>
            <Profile />
            <InfoPhoneVerifyModal />
            <VerifyProfileModal />
          </VerifyProfileProvider>

          <ChatRuleModal />
          <BunkerModal />
          <BunkerSuccessModal />
        </>
      </AppShell.Main>
    </AppShell>;
};